export const EDGE_EVENTS = [
  { value: 'matched', label: 'Matched' },
  { value: 'user_input', label: 'User input' },
  { value: 'valid', label: 'Valid' },
  { value: 'invalid', label: 'Invalid' },
  { value: 'completed', label: 'Completed' },
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'button_reply', label: 'Button reply' },
  { value: 'route', label: 'Route' },
];

export const EDGE_EVENT_LABELS = EDGE_EVENTS.reduce((acc, e) => {
  acc[e.value] = e.label;
  return acc;
}, {});
